import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authService } from '../api/services';
import type { Usuario } from '../types';

interface AuthContextData {
  usuario: Usuario | null;
  token: string | null;
  carregando: boolean;
  autenticado: boolean;
  login: (email: string, senha: string) => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [usuario, setUsuario] = useState<Usuario | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const tokenSalvo = localStorage.getItem('licmab_token');
    const usuarioSalvo = localStorage.getItem('licmab_usuario');
    if (tokenSalvo && usuarioSalvo) {
      try {
        setToken(tokenSalvo);
        setUsuario(JSON.parse(usuarioSalvo));
      } catch {}
    }
    setCarregando(false);
  }, []);

  const login = useCallback(async (email: string, senha: string) => {
    const resposta = await authService.login(email, senha);
    const { token: novoToken, usuario: novoUsuario } = resposta;
    localStorage.setItem('licmab_token', novoToken);
    localStorage.setItem('licmab_usuario', JSON.stringify(novoUsuario));
    setToken(novoToken);
    setUsuario(novoUsuario);
  }, []);

  const logout = useCallback(async () => {
    await authService.logout();
    setToken(null);
    setUsuario(null);
  }, []);

  return (
    <AuthContext.Provider value={{
      usuario,
      token,
      carregando,
      autenticado: !!token,
      login,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
